module.exports = __webpack_public_path__ + "media/images/icons/twitter-ff8dfead0509f45797288416d6cf6a3a.svg";